import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
	menu: false,
	pagelinks: null
}

const getters = {
	menu: state => {
		return state.menu;
	},
	pagelinks: state => {
		return state.pagelinks;
	}
}

const mutations = {
	toggle(state) {
		state.menu = !state.menu
	},
	pagelinks(state, data) {
		state.pagelinks = data
	}
}

const actions = {
	
}

const module = new Vuex.Store({
	state,
	getters,
	mutations,
	actions
})

export default module;
